var _path, _path2, _path3, _path4, _path5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaint(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 25,
    viewBox: "0 0 19 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.00188655 8.88904H0V11.2276H0.00188655V8.88904Z",
    fill: "url(#paint0_linear_65_277)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.00190181 23.7784V8.88904H1.52588e-05V23.7784C1.52588e-05 23.8314 0.0189159 23.8805 0.0548349 23.9297C0.0208063 23.8805 0.00190181 23.8295 0.00190181 23.7784Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.3521 6.90593C6.33697 6.90782 6.32374 6.90971 6.30861 6.90971V4.38403H2.93789V6.90971C2.92277 6.90971 2.90954 6.90782 2.89441 6.90593L0.00198364 8.88904V23.7784C0.00198364 23.8295 0.0208882 23.8805 0.0549167 23.9297C0.0662596 23.9467 0.0813836 23.9637 0.0965074 23.9788C0.122974 24.0072 0.155112 24.0336 0.191031 24.0601C0.260979 24.1111 0.349836 24.1603 0.455702 24.2076C0.484059 24.2208 0.514303 24.234 0.546441 24.2473C0.771408 24.3361 1.05876 24.4174 1.39527 24.4892C1.47845 24.5063 1.56352 24.5214 1.65237 24.5384C1.67317 24.5422 1.69396 24.546 1.71665 24.5497C1.76202 24.5573 1.80928 24.5649 1.85654 24.5724C1.91703 24.5838 1.97753 24.5913 2.03803 24.6008C2.40856 24.6556 2.8169 24.6972 3.2536 24.7255C3.32355 24.7312 3.39539 24.735 3.46723 24.7388C3.83587 24.7596 4.22342 24.7709 4.62231 24.7709C7.17634 24.7709 9.24452 24.3267 9.24452 23.7784V8.88904L6.3521 6.90593ZM3.54852 4.99466H5.69799V7.14413H3.54852V4.99466ZM8.63389 23.6083C8.25202 23.8257 6.86252 24.1603 4.62231 24.1603C2.38209 24.1603 0.994485 23.8257 0.612609 23.6083V9.6112C1.94728 9.81915 3.2933 9.92313 4.6242 9.92313C5.95509 9.92313 7.29922 9.81915 8.63389 9.6112V23.6083Z",
    fill: "#F19A3E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3432 0.550128L8.48444 4.78101L8.22166 4.22899L17.0785 0L17.3432 0.550128Z",
    fill: "#F19A3E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6382 11.9497L18.3263 12.4753L8.40883 6.54673L8.72265 6.02307L18.6382 11.9497Z",
    fill: "#F19A3E"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_65_277",
    x1: 0,
    y1: 10.0592,
    x2: 0.00188655,
    y2: 10.0592,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78B831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70B32C"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaint);
export default __webpack_public_path__ + "static/media/paint.038e403411fd0bb6662925dfe347b93a.svg";
export { ForwardRef as ReactComponent };